import d3 from 'd3';
import { mapKeys, toString, get } from 'lodash';

const rankCodes = [
    ['#4444'],
    ['#4444', '#ffffbf'],
    ['#4444', '#fc8d59', '#91cf60'],
    ['#f1f3f6', '#f3ad60', '#fce08b', '#abdda4'],
    ['#4444', '#d7191c', '#fdae61', '#a6d96a', '#1a9641'],
    ['#4444', '#d7191c', '#fdae61', '#ffffbf', '#a6d96a', '#1a9641'],
    ['#4444', '#d73027', '#fc8d59', '#fee08b', '#d9ef8b', '#91cf60', '#1a9850'],
    [
        '#4444',
        '#d73027',
        '#fc8d59',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#91cf60',
        '#1a9850',
    ],
    [
        '#4444',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
    ],
    [
        '#4444',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
    ],
    [
        '#4444',
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837',
    ],
    [
        '#4444',
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837',
    ],
];
const defaultCodes = {
    '40 000': '#abdda4',
    '41 000': '#f3ad60',
    '42 000': '#e6f598',
    '43 000': '#66c2a5',
    '44 000': '#ec6c41',
    '45 000': '#fce08b',
    '46 000': '#f3af60',
    '47 000': '#3588bd',
    properties: '#32a3dc',
    groups: '#2f2f2e',
    rank: rankCodes,
    waypoint: '#43a4dc',
    // deprecate
    bottom: '#fab36f',
    average: '#ffe294',
    top: '#addfab',
};

export function createColorScale(defaults, colorArr) {
    defaults = defaults || defaultCodes;

    defaults = Object.assign(
        {},
        defaults,
        mapKeys(defaults, (val, key) => key.replace(' ', '')),
        mapKeys(defaults, (val, key) => key.replace(' ', '_'))
    );

    let colors = d3.scale;

    if (colorArr) {
        colors = colors.ordinal().range(colorArr);
    } else {
        colors = colors.category20();
    }

    return function (target) {
        target = toString(target).toLowerCase();

        return get(defaults, target, null) || colors(target);
    };
}
